import React, { useState } from 'react';

const ITEMS = [
  { q: 'How long does the oil last?', a: 'Our oud oils are concentrated for longevity. Expect 8–12+ hours on skin from just 1–2 drops, with strong sillage in the first hours and a refined skin-close dry down.' },
  { q: 'How do I apply oud oil?', a: 'Apply 1–2 drops to pulse points: wrists, behind the ears, base of the neck. Let it settle. Do not rub. Less is luxury.' },
  { q: 'Do you offer free delivery?', a: 'Yes. Free UK delivery on every order. Carefully packed and gift-ready.' },
  { q: 'What size is available?', a: 'Every fragrance is available as a 12ml oud oil for £30.' },
  { q: 'Can I pay by card?', a: 'Yes. Secure card checkout is powered by Stripe at the end of your bag. We never see or store your card details.' },
  { q: 'Can I order through WhatsApp?', a: 'Of course. WhatsApp ordering is fully active for help choosing scents, gift wrapping, and bank transfer.' },
  { q: 'Are the oils suitable as gifts?', a: 'Yes. Every order arrives gift-ready. Popular for Eid, birthdays, weddings, anniversaries and personal signature scents.' },
  { q: 'How do I choose the right scent?', a: 'Use the Fragrance Finder above to narrow by mood, or message us on WhatsApp — we will guide you personally.' },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="section" id="faq">
      <div className="container" style={{ maxWidth: 820 }}>
        <div className="section-head" style={{ alignItems: 'center', textAlign: 'center' }}>
          <span className="eyebrow">Atelier Notes</span>
          <h2>Frequently asked</h2>
        </div>
        <div>
          {ITEMS.map((it, i) => (
            <div key={i} className={`faq-item ${open === i ? 'open' : ''}`}>
              <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)} aria-expanded={open === i}>
                <span>{it.q}</span>
                <span className="ico">+</span>
              </button>
              <div className="faq-a"><p style={{ margin: 0 }}>{it.a}</p></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
